
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import styles from '../../Maintenance/create/workOrderCreate.module.scss';
import icon from '../../../icons/badging.png';
import Panel from '../../../components/panel';
import Button from '../../../components/button/button';
import checkboxStyles from './selectApplication.module.scss';

class SelectApplication extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      checkboxValid: false,
      selectedCheckBox: 0,
      formValid: false,
      checkboxName: '',
      list: [
        { check: 'manually', name: 'Signatory will fill up the application.' },
        { check: 'email', name: 'Applicant will fill up the application.' }
      ]
    };
  }

    validateForm = () => {
      const { checkboxValid } = this.state;
      this.setState({ formValid: checkboxValid });
    };

    updateCheckbox = ({ name, checked }) => {
      this.setState(
        prev => ({
          selectedCheckBox: checked
            ? prev.selectedCheckBox + 1
            : prev.selectedCheckBox - 1,
          checkboxName: name
        }),
        this.validateCheckbox
      );
    };

    validateCheckbox = () => {
      const { selectedCheckBox } = this.state;
      if (selectedCheckBox < 1) {
        this.setState({ checkboxValid: false });
      }
      this.setState({ checkboxValid: true }, this.validateForm);
    };

    handleNext = () => {
      const { checkboxName } = this.state;
      const { history } = this.props;

      if (checkboxName === 'email') {
        history.push('/badging/new');
      } else {
        history.push('/badging/form');
      }
    }

    selectBox = (check, name, index) => {
      const { checkboxName } = this.state;
      return (
        <div className={`${checkboxStyles.checkboxWrapper16}`} key={index}>
          <label className={checkboxStyles.checkboxWrapper}>
            <input
              name={check} type="checkbox"
              className={checkboxStyles.checkboxInput}
              onChange={e => this.updateCheckbox(e.target)}
              checked={checkboxName === check}
            />
            <span className={checkboxStyles.checkboxTile}>
              <span className={checkboxStyles.checkboxIcon}>
                <p className={checkboxStyles.checkboxIconText}>
                  <FormattedMessage id="name" defaultMessage={name} />
                </p>
              </span>
            </span>
          </label>
        </div>
      );
    }

    render() {
      const { formValid, list } = this.state;
      return (
        <>
          <SectionHeader
            icon={icon}
            translationID="topbar.badging.new"
            defaultTitle="New Badge Application"
          />
          <HeaderBack
            translationID="workorder.settings.back"
            translationDefault="Back"
            backRoute="/badging/List"
          />
          <div className={`container ${styles.form}`}>
            <Panel
              title="badge.select.Application"
              defaultTitle="New Badge Application"
              fromGate
              contentClasses={styles.panelContent}
            >
              <div className={checkboxStyles.selectMainBoxItem}>
                <div className={checkboxStyles.selectMainBoxItemHeading}>
                  <FormattedMessage id="title" defaultMessage="Allow Signatory to Initiate Application" />
                </div>
                <div className={checkboxStyles.selectMainBoxItemCheckbox}>
                  { list?.map((item, index) => this.selectBox(item.check, item.name, index)) }
                </div>
              </div>
              <div className={`${styles.footer} ${styles.embedded}`} style={{ justifyContent: 'flex-end', marginTop: '50px' }}>
                <Button onClick={() => this.handleNext()} translationID="next" className="mt-2 mb-2"
                  defaultText="Next" action="secondary" disabled={!formValid}
                />
              </div>
            </Panel>
          </div>
        </>
      );
    }
}

SelectApplication.propTypes = {
  match: PropTypes.shape({}).isRequired
};

export default memo(injectIntl(SelectApplication));
